import { PricingPlanPeriod } from "../../../shared/types/pricingPlanTypes";

export type PricingPlanTypeUsa = "LITE" | "MEDIUM" | "UNLIMITED";

export interface PricingPlanUsa {
  type: PricingPlanTypeUsa;
  periodOfTime: PricingPlanPeriod;
  benefits: string[];
  disadvantages?: string[];
  numberOfNotifications: number;
  price: number; // Fallback price (hardcoded)
  priceId?: string;
  stripeProductName: string;
  apiPrice?: number; // Actual price from Stripe API (in cents)
}

export const yearPricingPlansUsa: PricingPlanUsa[] = [
  {
    type: "LITE",
    periodOfTime: "year",
    benefits: [
      "unlimitedNotifications",
      "notificationsWithStatistics",
      "notificationsWithLastOrdersAndRegistrations",
      "notificationPersonalization",
      "googleRecenze",
      "trustPilot",
    ],
    disadvantages: ["customBranding", "logoCancel"],
    numberOfNotifications: 6000,
    price: 50,
    stripeProductName: "LITE",
  },
  {
    type: "MEDIUM",
    periodOfTime: "year",
    benefits: [
      "unlimitedNotifications",
      "notificationsWithStatistics",
      "notificationsWithLastOrdersAndRegistrations",
      "notificationPersonalization",
      "googleRecenze",
      "trustPilot",
    ],
    disadvantages: ["customBranding", "logoCancel"],
    numberOfNotifications: 50000,
    price: 200,
    stripeProductName: "MEDIUM",
  },
  {
    type: "UNLIMITED",
    periodOfTime: "year",
    benefits: [
      "unlimitedNotifications",
      "notificationsWithStatistics",
      "notificationsWithLastOrdersAndRegistrations",
      "notificationPersonalization",
      "googleRecenze",
      "trustPilot",
      "customBranding",
      "logoCancel",
    ],
    numberOfNotifications: Infinity,
    price: 350,
    stripeProductName: "UNLIMITED",
  },
];

export const monthPricingPlansUsa: PricingPlanUsa[] = [
  {
    type: "LITE",
    periodOfTime: "month",
    benefits: [
      "unlimitedNotifications",
      "notificationsWithStatistics",
      "notificationsWithLastOrdersAndRegistrations",
      "notificationPersonalization",
      "googleRecenze",
      "trustPilot",
    ],
    disadvantages: ["customBranding", "logoCancel"],
    numberOfNotifications: 6000,
    price: 5,
    stripeProductName: "LITE",
  },
  {
    type: "MEDIUM",
    periodOfTime: "month",
    benefits: [
      "unlimitedNotifications",
      "notificationsWithStatistics",
      "notificationsWithLastOrdersAndRegistrations",
      "notificationPersonalization",
      "googleRecenze",
      "trustPilot",
    ],
    disadvantages: ["customBranding", "logoCancel"],
    numberOfNotifications: 50000,
    price: 20,
    stripeProductName: "MEDIUM",
  },
  {
    type: "UNLIMITED",
    periodOfTime: "month",
    benefits: [
      "unlimitedNotifications",
      "notificationsWithStatistics",
      "notificationsWithLastOrdersAndRegistrations",
      "notificationPersonalization",
      "googleRecenze",
      "trustPilot",
      "customBranding",
      "logoCancel",
    ],
    numberOfNotifications: Infinity,
    price: 35,
    stripeProductName: "UNLIMITED",
  },
];
